const NEW_FIRST_BIRTHDAY_LISTING_IDS = new Set([
  "testfb0001_p_1071f",
  "testfb0002_p_8900d",
  "testfb0003_p_e8880",
  "testfb0004_p_0ea29",
  "testfb0005_p_30a03",
  "testfb0006_p_91d35",
  "testfb0007_p_f6f50",
  "testfb0008_p_fb08e",
  "testfb0009_p_cd5af",
  "testfb0010_p_1ed4e",
  "testfb0011_p_d83cc",
  "testfb0012_p_155e9",
  "testfb0013_p_c207b",
  "testfb0014_p_a0afc",
  "testfb0015_p_dd446",
  "testfb0016_p_3c833",
  "testfb0017_p_4b3f8",
  "testfb0018_p_607fb",
  "testfb0019_p_99100",
  "testfb0020_p_e4970",
  "testfb0021_p_3f89d",
  "testfb0022_p_3f94a",
  "testfb0023_p_89e38",
  "testfb0024_p_5cd23",
  "testfb0025_p_0880e",
  "testfb0026_p_9250a",
  "testfb0027_p_95145",
  "testfb0028_p_fb3dc",
  "testfb0029_p_edc37",
  "testfb0030_p_cf5bd",
  "testfb0031_p_e5ca9",
  "testfb0032_p_d1c9d",
  "testfb0033_p_9c6db",
  "testfb0034_p_c8d89",
  "testfb0035_p_e4a13",
  "testfb0036_p_da4ce",
  "testfb0037_p_ac087",
  "testfb0038_p_94086",
  "testfb0039_p_2394a",
  "testfb0040_p_e10e3",
  "testfb0041_p_91614",
  "testfb0042_p_95d79",
  "testfb0043_p_ca253",
  "testfb0044_p_a3cce",
  "testfb0045_p_ff70a",
  "testfb0046_p_2e7bc",
  "testfb0047_p_6d8b4",
  "testfb0048_p_8d545",
  "testfb0049_p_c482d",
  "testfb0050_p_2f4c1",
  "testfb0051_p_cc69d",
  "testfb0052_p_8d75e",
  "testfb0053_p_9c900",
  "testfb0054_p_f32ec",
  "testfb0055_p_eb507",
  "testfb0056_p_f25dc",
  "testfb0057_p_12013",
  "testfb0058_p_fea0a",
]);

const BUTTERFLY_THEME_TOKENS = ["butterfly"];

const normalizeBadgeText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const isFirstBirthdayListing = (product) =>
  normalizeBadgeText(product?.mainCategory) === "first birthday decorations";

const isButterflyListing = (product) => {
  const searchableText = normalizeBadgeText(
    [
      product?.title,
      product?.slug,
      ...(Array.isArray(product?.keywords) ? product.keywords : []),
      product?.primaryKeyword,
      product?.secondaryKeyword1,
      product?.secondaryKeyword2,
    ].join(" ")
  );

  return BUTTERFLY_THEME_TOKENS.some((token) => searchableText.includes(token));
};

export const getListingBadges = (product) => {
  if (!product || !isFirstBirthdayListing(product)) return [];

  const badges = [];
  const productId = String(product.id || product.ID || "").trim();
  const isNewListing = NEW_FIRST_BIRTHDAY_LISTING_IDS.has(productId);

  if (isNewListing) {
    badges.push({ key: "new", label: "New", tone: "new" });
  }

  if (isNewListing && isButterflyListing(product)) {
    badges.push({ key: "trending", label: "Trending", tone: "trending" });
  }

  return badges;
};

export const NEW_FIRST_BIRTHDAY_LISTING_COUNT = NEW_FIRST_BIRTHDAY_LISTING_IDS.size;
